import React from 'react';
import { API } from 'aws-amplify';
import { toast } from 'react-toastify';

import { basicReducer as reducer } from '../../../../utils/reducers';

const useExportData = () => {
    const initialState = {
        fileName: '',
        isDoingAjax: false,
    };
    const [state, dispatch] = React.useReducer(reducer, initialState);

    const sendReport = async (selected, closeCallback) => {
        dispatch({
            type: 'doingAjax',
        });

        try {
            await API.post('ShipyardAPI', '/admin/lnh_report', {
                body: {
                    selected,
                    fileName: state.fileName,
                },
            });

            toast.success('Export is generating. You will be notified when it\'s ready for download.');

            dispatch({
                type: 'update',
                newState: initialState,
            });

            closeCallback?.();
        } catch (e) {
            toast.error('API error occurred.');
            dispatch({
                type: 'ajaxDone',
            });
        }
    };

    const handleFileName = (event) => {
        dispatch({
            type: 'update',
            newState: {
                fileName: event.target.value,
            },
        });
    };

    return {
        ...state,
        sendReport,
        handleFileName,
    };
};

export default useExportData;
